import {useCallback} from 'react';
import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import {fetchPendingOrders} from '../../../product/infrastructure/pendingOrderApi';
import {mapRemoteData} from '../../../common/domain/RemoteData.model';
import {useComercialContext} from '../../../comercial/ComercialContext';

/**
 * Swiper de la home con los pendientes que TODAVÍA están en espera de stock.
 *
 * Deja fuera a propósito los que ya tienen stock (isRestocked): esos los pinta
 * RestockedPendingProducts, que es la sección accionable. Así las dos secciones
 * de la home son disjuntas y ningún producto sale dos veces.
 */
export const PendingProductsSwiper = () => {
    const {actingAsCliente} = useComercialContext();
    const actingAs = actingAsCliente?.numCliente ?? null;

    const fetchFn = useCallback(
        () => fetchPendingOrders(actingAs).then((remoteData) =>
            mapRemoteData(remoteData, (pendingOrders) =>
                (pendingOrders ?? [])
                    .filter((pendingOrder) => !pendingOrder.isRestocked)
                    .map((pendingOrder) => pendingOrder.product)
            )
        ),
        [actingAs]
    );

    return (
        <ProductSwiper title={'TUS PENDIENTES (EN ESPERA)'} fetchFn={fetchFn} />
    );
};
